import {
  DesktopTimePicker,
  DesktopTimePickerProps,
} from "@mui/x-date-pickers/DesktopTimePicker";

export type { DesktopTimePickerProps };
export default DesktopTimePicker;
